import { render, staticRenderFns } from "./DrugUseRemindList.vue?vue&type=template&id=43a47e2b&scoped=true&"
import script from "./DrugUseRemindList.vue?vue&type=script&lang=js&"
export * from "./DrugUseRemindList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a47e2b",
  null
  
)

export default component.exports